import { useWidgetPostMessages } from '@widgets/messenger/utils/postMessages'

export interface OpenLinkPayload {
  href: string
  openInNewWindow: boolean
}

const useOpenLinkMessages = (widgetId: string) => useWidgetPostMessages<OpenLinkPayload>(widgetId, 'textmagicOpenLink')

export const sendOpenLinkMessage = (widgetId: string, href: string, openInNewWindow: boolean) => {
  useOpenLinkMessages(widgetId).sendToParent({ href, openInNewWindow })
}

export const subscribeOnOpenLinkMessages = (widgetId: string, callback: (payload: OpenLinkPayload) => void) => {
  return useOpenLinkMessages(widgetId).subscribe((event) => {
    callback(event.data.payload)
  })
}
